import { useContext } from 'react';

import { CommboxPermissionsContext } from '../contexts/commbox-permission-context';

export const useCommboxPermissions = () => {
  const context = useContext(CommboxPermissionsContext);

  return context;
};
